import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import HeroSection from "@/components/home/HeroSection";
import ServicesSection from "@/components/home/ServicesSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import ServiceAreasSection from "@/components/home/ServiceAreasSection";
import CTASection from "@/components/home/CTASection";
import { SEO } from "@/components/SEO";
import { CheckCircle } from "lucide-react";
import { services } from "@/components/home/ServicesSection";
import QuoteRequestSection from "@/components/home/QuoteRequestSection";
import AboutUsSection from "@/components/home/AboutUsSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import FAQSection from "@/components/home/FAQSection";
import BlogSection from "@/components/home/BlogSection";

// Import content from the Services page
import { Card, CardContent } from "@/components/ui/card";
import { servicedCities } from "@/constants/cities";

const Index = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-in");
            entry.target.classList.remove("opacity-0");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    // Check if there's a hash in the URL and scroll to that section
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <SEO
        title="Mobile Detail Co. | Professional Auto Detailing Services"
        description="Expert mobile detailing services that come to your location. Eco-friendly car wash, interior detailing, ceramic coating, and more."
        image="/og-image.png"
      />
      
      <div className="min-h-screen">
        {/* Hero Section with Slider */}
        <section id="hero">
          <HeroSection />
        </section>
        {/* Quote Request Section */}
        <QuoteRequestSection />
        {/* About Us Section */}
        <AboutUsSection />
        {/* Services Section */}
        <ServicesSection />
        {/* Features Section with Icons */}
        <section id="features" className="bg-white">
          <FeaturesSection />
        </section>
        {/* Testimonials Section */}
        <TestimonialsSection />
        {/* Areas We Serve Section */}
        <section id="locations" className="bg-white">
          <div id="areas-we-serve">
            <ServiceAreasSection />
          </div>
        </section>
        {/* FAQ Section */}
        <FAQSection />
        {/* Blog Section */}
        <BlogSection />
        {/* Final CTA Section */}
        <section className="bg-white">
          <CTASection />
        </section>
      </div>
    </>
  );
};

export default Index;
